import * as React from "react";

/**
 * Context that exposes the DOM node Radix portals should render into.
 *
 * Why: with Tailwind's `important: '.d2cbot-container'` scoping, any portal
 * rendered into `document.body` (outside the wrapper) loses all utility
 * styles. The widget mounts a sibling `<div class="d2cbot-container">` and
 * provides it here so portal-using primitives (Dialog, Popover, Select, etc.)
 * can render inside a styled root.
 *
 * In the admin app this context is undefined → primitives fall back to
 * Radix's default (document.body), preserving existing behavior.
 */
export const PortalRootContext = React.createContext<HTMLElement | null>(null);

export function usePortalRoot(): HTMLElement | undefined {
  const node = React.useContext(PortalRootContext);
  return node ?? undefined;
}
